import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { listenForInstallPrompt } from './utils/installApp';

// Before React mounts, so the browser's install offer is never missed.
listenForInstallPrompt();

// iOS Safari only applies :active styles once a touch listener exists on the
// page; without this, press feedback (index.css) never shows on iPhones/iPads.
document.addEventListener('touchstart', () => {}, { passive: true });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA support.
// onUpdate fires when a new version of the app is available.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Store registration globally so the app can trigger skipWaiting
    window.__SW_REGISTRATION = registration;
    // Dispatch a custom event the app can listen to
    window.dispatchEvent(new CustomEvent('sw-update-available'));
  },
  onSuccess: () => {
    console.log('PWA: App is now available offline.');
  },
});
